import { Link } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { skipToMainContentLink } from './SkipToMainContent.styles';

export const MAIN_CONTENT_ID = 'main-content';

export const focusMainContent = () => {
  const mainContent = document.getElementById(MAIN_CONTENT_ID);

  if (!mainContent) {
    return;
  }

  mainContent.focus({ preventScroll: false });

  if (window.location.hash !== `#${MAIN_CONTENT_ID}`) {
    window.history.replaceState(null, '', `#${MAIN_CONTENT_ID}`);
  }
};

export const SkipToMainContent = () => {
  const { t } = useTranslation();

  const handleSkipClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    focusMainContent();
  };

  return (
    <Link href={`#${MAIN_CONTENT_ID}`} onClick={handleSkipClick} sx={skipToMainContentLink}>
      {t('accessibility.skipToMainContent')}
    </Link>
  );
};
